import React from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

const Results = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper caseName="gens-results">
                <div className="gens-results__wrapper">
                    <div className="gens-results__info">
                        <CommonTitle>Результаты</CommonTitle>
                        <CommonSmallText isOneParagraph={false}>
                            В&nbsp;результате мы&nbsp;создали платформу главного технологического
                            акселератора страны, которая собрала более 16000 заявок
                            на&nbsp;акселерацию от&nbsp;стартапов, образовала благоприятную
                            экосистему по&nbsp;развитию бизнес и&nbsp;экономики страны в&nbsp;целом.{' '}
                        </CommonSmallText>
                        <CommonSmallText isOneParagraph={false}>
                            С&nbsp;помощью платформы проведен отбор лучших проектов
                            в&nbsp;28&nbsp;акселераторов и&nbsp;треков для таких компаний как
                            Unilever, ВТБ, Airbus, Michelin, Алроса, ИЛИМ, ЧТПЗ, ГТЛК и&nbsp;др.
                        </CommonSmallText>
                    </div>
                    <div className="gens-results__img">
                        <img src="/images/svg/gens/gens-results-img1.svg" alt="" loading="lazy" />
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Results;
